import { marked } from 'marked'

// FAQ Data Structure
interface FAQ {
  id: string
  question: string
  answer: string
}

interface FAQSection {
  title: string
  icon: string
  faqs: FAQ[]
}

// Function to parse markdown to FAQ structure
export function parseMarkdownToFAQs(markdown: string): FAQSection[] {
  const sections: FAQSection[] = []
  const lines = markdown.split('\n')
  
  let currentSection: FAQSection | null = null
  let currentFAQ: FAQ | null = null
  let answerLines: string[] = []
  
  const sectionIcons: Record<string, string> = {
    'Getting Started': 'mdi-play',
    'Assessment Process': 'mdi-clipboard-check',
    'Booking & Scheduling': 'mdi-calendar-check',
    'Payment & Pricing': 'mdi-credit-card',
    'Results & Reports': 'mdi-chart-line',
    'Technical Support': 'mdi-help-circle'
  }
  
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]
    
    if (!line) continue
    
    // Check for section header (## Level 2)
    if (line.startsWith('## ')) {
      // Save previous FAQ if exists
      if (currentFAQ && currentSection) {
        const answerMarkdown = answerLines.join('\n').trim()
        currentFAQ.answer = marked(answerMarkdown, { async: false }) as string
        currentSection.faqs.push(currentFAQ)
        currentFAQ = null
        answerLines = []
      }
      
      const sectionTitle = line.substring(3).trim()
      currentSection = {
        title: sectionTitle,
        icon: sectionIcons[sectionTitle] || 'mdi-help-circle',
        faqs: []
      }
      sections.push(currentSection)
    }
    // Check for FAQ question (### Level 3)
    else if (line.startsWith('### ')) {
      // Save previous FAQ if exists
      if (currentFAQ && currentSection) {
        const answerMarkdown = answerLines.join('\n').trim()
        currentFAQ.answer = marked(answerMarkdown, { async: false }) as string
        currentSection.faqs.push(currentFAQ)
        answerLines = []
      }
      
      const question = line.substring(4).trim()
      currentFAQ = {
        id: question.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''),
        question: question,
        answer: ''
      }
    }
    // Collect answer lines
    else if (currentFAQ) {
      answerLines.push(line)
    }
  }
  
  // Save last FAQ if exists
  if (currentFAQ && currentSection) {
    const answerMarkdown = answerLines.join('\n').trim()
    currentFAQ.answer = marked(answerMarkdown, { async: false }) as string
    currentSection.faqs.push(currentFAQ)
  }
  
  return sections
}

// Export types for use in components and tests
export type { FAQ, FAQSection }